import React, { useState, useEffect } from "react";

const UnicodeGame = () => {
const words = [
  "HELLO", "WORLD", "FUN", "UNICODE", "GAME", "PYTHON", "😊🎉", "123",
  "CODE", "JAVASCRIPT",  "EXPO", "APP", "MOBILE", "TABLE",
  "KEYBOARD", "MONITOR", "ALGORITHM", "DATA", "DEBUG", "ERROR", "SUCCESS",
  "🚀🌟", "💻🖥️", "🎮🕹️", "12345", "67890", "A1B2C3", "!@#$%", "&*()?/", 
  "PYTHON3", "ARRAY", "OBJECT", "FUNCTION", "STRING", "NUMBER", "BOOLEAN"
];
  const tables = {
    upper: "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split(''),
    lower: "abcdefghijklmnopqrstuvwxyz".split(''),
    numbers: "0123456789".split(''),
    emoji: ["😊","😂","🎉",,"👍","🚀"],
    symbols: ["!","@","#","$","%","&","*","?"]
  };

  const [currentWord, setCurrentWord] = useState("");
  const [unicodeStr, setUnicodeStr] = useState("");
  const [userInput, setUserInput] = useState("");
  const [feedback, setFeedback] = useState("");
  const [category, setCategory] = useState("upper");

  const getUnicodeString = (word) =>
    word.split('').map(c => "U+" + c.charCodeAt(0).toString(16).toUpperCase().padStart(4,'0')).join(' ');

  const pickNewWord = () => {
    const word = words[Math.floor(Math.random() * words.length)];
    setCurrentWord(word);
    setUnicodeStr(getUnicodeString(word));
    setUserInput("");
    setFeedback("");
  };

  const checkAnswer = () => {
    if(userInput.trim().toUpperCase() === currentWord.toUpperCase()) {
      setFeedback("✅ Correct!");
    } else {
      setFeedback("❌ Try again.");
    }
  };

  useEffect(() => {
    pickNewWord();
  }, []);

  const styles = {
    root: {
      fontFamily: "Poppins, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
      background: "linear-gradient(120deg, #c3ecf7, #f0faff)",
      minHeight: "100vh",
      padding: 28,
      display: "flex",
      justifyContent: "center",
    },
    card: {
      background: "#fff",
      padding: 28,
      borderRadius: 20,
      maxWidth: 900,
      width: "100%",
      boxShadow: "0 15px 40px rgba(0,0,0,0.12)",
    },
    h1: { textAlign: "center", color: "#4b6cb7", marginBottom: 10 },
    meta: { textAlign: "center", color: "#555", marginBottom: 20 },
    container: { display: "flex", gap: 20, flexWrap: "wrap" },
    left: { flex: "1 1 45%", minWidth: 300 },
    right: { flex: "1 1 45%", minWidth: 300 },
    select: {
      padding: 10,
      fontSize: 16,
      borderRadius: 12,
      border: "1px solid #d8dbe9",
      textAlign: "center",
      background: "#f9f9ff",
      marginBottom: 10,
      width: "100%"
    },
    table: {
      borderCollapse: "collapse",
      width: "100%",
      display: "block",
      maxHeight: 400,
      overflowY: "auto",
    },
    th: { padding: 8, textAlign: "center", border: "1px solid #d8dbe9", background: "#4b6cb7", color: "#fff" },
    td: { padding: 8, textAlign: "center", border: "1px solid #d8dbe9" },
    unicodeDisplay: {
      textAlign: "center",
      fontFamily: "monospace",
      fontSize: 20,
      marginBottom: 15,
      padding: 12,
      background: "linear-gradient(135deg, #f9f9ff, #e3f2ff)",
      borderRadius: 14,
      wordBreak: "break-word",
    },
    input: {
      padding: 10,
      fontSize: 16,
      borderRadius: 12,
      border: "1px solid #d8dbe9",
      width: 150,
      textAlign: "center",
      background: "#f9f9ff",
      marginRight: 10
    },
    button: {
      padding: "10px 18px",
      fontWeight: 700,
      fontSize: 14,
      borderRadius: 12,
      border: "none",
      cursor: "pointer",
      color: "#fff",
      transition: "0.3s",
    },
    feedback: { fontWeight: 700, marginTop: 12, fontSize: 16, textAlign: "center" },
    small: { fontSize: 12, color: "#555", marginTop: 6, textAlign: "center" }
  };

  return (
    <div style={styles.root}>
      <div style={styles.card}>
        <h3 style={styles.h1}>Decode the Unicode! </h3>
        <div style={styles.meta}>Use the reference table to decode the Unicode codes on the right.</div>

        <div style={styles.container}>
          {/* Left: Reference Table */}
          <div style={styles.left}>
            <label>Reference Table:</label>
            <select style={styles.select} value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="upper">A-Z</option>
              <option value="lower">a-z</option>
              <option value="numbers">0-9</option>
              <option value="emoji">Emojis</option>
              <option value="symbols">Symbols</option>
            </select>

            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Char</th>
                  <th style={styles.th}>Unicode</th>
                </tr>
              </thead>
              <tbody>
                {tables[category].map((c, idx) => (
                  <tr key={idx} style={idx % 2 === 0 ? { background: "#f0f4ff" } : {}}>
                    <td style={styles.td}>{c}</td>
                    <td style={styles.td}>U+{c.charCodeAt(0).toString(16).toUpperCase().padStart(4,'0')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={styles.small}>Click a category to see its characters and Unicode codes.</div>
          </div>

          {/* Right: Activity Area */}
          <div style={styles.right}>
            <div style={styles.unicodeDisplay}>{unicodeStr}</div>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
              <input
                style={styles.input}
                type="text"
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                placeholder="Type your answer"
              />
              <button style={{ ...styles.button, background: "#27ae60" }} onClick={checkAnswer}>Check Answer</button>
              <button style={{ ...styles.button, background: "#e67e22" }} onClick={pickNewWord}>New Word</button>
            </div>
            <p style={{ ...styles.feedback, color: feedback.includes("✅") ? "#27ae60" : "#e74c3c" }}>{feedback}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnicodeGame;
